import { render } from "./PuzzleBoard.vue?vue&type=template&id=04617a65"
import script from "./PuzzleBoard.vue?vue&type=script&lang=js"
export * from "./PuzzleBoard.vue?vue&type=script&lang=js"

import "./PuzzleBoard.vue?vue&type=style&index=0&id=04617a65&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__